<header id="top" class="header{{ isMobile ? ' mobile' : '' }}">
  <div class="flex">
    <div class="left">
      <nav class="home-link-wrapper">
        <a [routerLink]="'/'" class="home-link">
          <span class="caption">{{ labels.dataReport }}</span>
        </a>
      </nav>
      @if (isDetailPage) {
        <div class="map-title">
          <p>{{ labels.mapTitleHeader }}</p>
          <a [href]="mapUrl" target="_blank"> {{ mapTitle }} </a>
        </div>
      }
    </div>

    <div class="right">
      @if (isDetailPage) {
        <app-data-type-filter></app-data-type-filter>
      }
      @if (isDetailPage) {
        <app-date-filter></app-date-filter>
      }
      @if (isDetailPage) {
        <nav>
          <app-download-button></app-download-button>
        </nav>
      }

      @if (!authedUserProfile) {
        <nav class="not-login">
          <p>
            <a href="{{ authApiHost }}/login"
              >stroly.comにてログインしてください</a
            >
          </p>
        </nav>
      }
      @if (hasAuthedUserProfile && authedUserProfile.extended_userprofile) {
        <nav class="user" [ngStyle]="pcMode">
          <img
            class="icon"
            src="{{ avatarUrl }}"
            (click)="toggleUserMenu()"
            [style.visibility]="loading ? 'hidden' : 'visible'"
          />
          <div
            class="user-nav-overlay"
            [ngStyle]="active"
            (click)="toggleUserMenu()"
          ></div>
          <div class="user-nav" [class.mobile]="isMobile" [ngStyle]="active">
            <div class="user-info">
              @if (isMobile) {
                <img class="icon" src="{{ avatarUrl }}" />
              }
              <div>
                <p class="user-detail">
                  <span class="user-name">{{
                    authedUserProfile.extended_userprofile.name
                  }}</span
                  ><br />
                  <span class="user-email">{{
                    authedUserProfile.extended_userprofile.email
                  }}</span>
                </p>
              </div>
            </div>
            @if (isMobile) {
              <a (click)="changeToPCMode()">{{ labels.changePCMode }}</a>
            }
            @if (under1024px) {
              <a (click)="changeToSPMode()">{{ labels.changeSPMode }}</a>
            }
            <ul class="menu">
              <li>
                <a href="{{ strolyURL + '/mypage/' }}">{{ labels.myPage }}</a>
              </li>
              @if (isMobile) {
                <li>
                  <a href="https://stroly.com/guide/">{{ labels.helpGuide }}</a>
                </li>
              }
              @if (isMobile) {
                <li>
                  <a href="https://stroly.com/terms/">{{ labels.terms }}</a>
                </li>
              }
              @if (isMobile) {
                <li>
                  <a href="https://stroly.com/privacy/">{{
                    labels.privacyPolicy
                  }}</a>
                </li>
              }
              @if (isMobile) {
                <li>
                  <a
                    href="{{
                      language == 'ja'
                        ? 'https://corp.stroly.com/'
                        : 'https://corp.stroly.com/en/'
                    }}"
                    >{{ labels.operatingCompany }}</a
                  >
                </li>
              }
            </ul>
            <a
              class="logout"
              [routerLink]="[]"
              queryParamsHandling="preserve"
              (click)="logout()"
              >{{ labels.logOut }}</a
            >
            @if (isMobile) {
              <img
                src="./assets/close-icon.png"
                class="close"
                (click)="toggleUserMenu()"
              />
            }
          </div>
        </nav>
      }

      <!-- <a *ngIf="!isMobile" href="https://stroly.com/">
              <img src="./assets/stroly-logo.png" alt="stroly" class="logo" />
            </a> -->
    </div>
    <a
      pageScroll
      [pageScrollDuration]="scrollDuration"
      href="#summary"
      class="to-top"
      [class.to-top-visible]="toTopButtonVisible"
      [class.to-top-hidden]="!toTopButtonVisible"
      [ngStyle]="toTopBtnPos"
    >
      <img src="./assets/pagetop.svg" />
    </a>
  </div>
</header>
